import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-template',
  imports: [],
  templateUrl: './loader-template.html',
  styleUrl: './loader-template.css',
})
export class LoaderTemplate {
  img1: string = 'assets/images/loader1.gif';
}
